import { UnstyledButton } from '../UnstyledButton'

type RedactFullStringProps = {
  text: string
  onClick: () => void
}

export const RedactFullString = ({ text, onClick }: RedactFullStringProps) => {
  return (
    <UnstyledButton
      className='transition-all hover:bg-[#062D46] hover:text-[#062D46]'
      style={{
        color: 'inherit',
        fontSize: 'inherit',
        fontWeight: 'inherit',
        fontFamily: 'inherit',
      }}
      onClick={onClick}
    >
      {text}
    </UnstyledButton>
  )
}
